import React from 'react';
import { motion } from 'framer-motion';
import { REEL_IMAGES, INSTAGRAM_URL, BRAND_COLOR } from '../constants';

const Contact: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => (
  <section id="contact" className={`py-24 md:py-32 border-t transition-colors duration-500 ${isDarkMode ? 'bg-black border-white/5' : 'bg-white border-zinc-100'} overflow-hidden`}>
    <div className="max-w-7xl mx-auto px-6 text-center mb-20 md:mb-28">
      <div className="relative inline-block mb-10 md:mb-14">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={`font-display text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black uppercase leading-[0.8] italic tracking-tighter ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          READY?
        </motion.h2>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          viewport={{ once: true }}
          style={{ color: BRAND_COLOR }}
          className={`font-display text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black uppercase leading-[0.8] italic tracking-tighter -mt-3 sm:-mt-5 md:-mt-8`}
        >
          LET'S SHOOT.
        </motion.h2>
      </div>
      
      <div className="flex justify-center">
        <motion.a 
          href={INSTAGRAM_URL} 
          target="_blank" 
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          style={{ backgroundColor: BRAND_COLOR }} 
          className="inline-block px-10 md:px-14 py-5 md:py-6 text-black font-black uppercase tracking-[0.25em] text-xs md:text-sm shadow-xl transition-all hover:brightness-110"
        >
          DM ON INSTAGRAM
        </motion.a>
      </div>
    </div>
    
    <div className={`flex gap-4 md:gap-6 animate-marquee whitespace-nowrap border-y py-8 md:py-10 ${isDarkMode ? 'border-white/5' : 'border-black/5'}`}>
      {[...REEL_IMAGES, ...REEL_IMAGES].map((img, i) => (
        <div key={i} className={`w-40 h-56 md:w-64 md:h-80 flex-shrink-0 transition-colors duration-500 ${isDarkMode ? 'bg-zinc-900 border-white/10' : 'bg-zinc-100 border-black/5'} border transition-all duration-700`}>
          <img src={img} className="w-full h-full object-cover" loading="lazy" alt="Work highlight" />
        </div>
      ))}
    </div>

    <style>{`
      @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      .animate-marquee { animation: marquee 35s linear infinite; }
      @media (max-width: 768px) {
        .animate-marquee { animation: marquee 25s linear infinite; }
      }
      .animate-marquee:hover { animation-play-state: paused; }
    `}</style>
  </section>
);

export default Contact;